const getUrlParams = () => {
    const params = new URLSearchParams(window.location.search);
    const colour = params.get('colour');
    return colour;
};

export default getUrlParams;
